import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService, SettingFormDTO } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { updateSettingsForm } = EventsApiService();

export const useSettingsUpdateForm = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: SettingFormDTO) => {
            return updateSettingsForm(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success('Event Setting has been updated successfully!!');
            },
        },
    );
};
